// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-detail[data-v-5a44e394]{overflow:hidden}.layout-detail .bread[data-v-5a44e394]{margin-bottom:20px}.layout-detail .bread .breadcrumb[data-v-5a44e394]{color:#333}.layout-detail .left[data-v-5a44e394]{float:left;width:840px}.layout-detail .right[data-v-5a44e394]{float:right;width:350px}.layout-detail .contentData[data-v-5a44e394]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
